export interface IRequestReviewDocumentNoteEnvelope {
  requestReviewDocumentNotesDto: IRequestReviewDocumentNote[];
  requestReviewDocumentNoteCount: number;
}

export interface IRequestReviewDocumentNote {
  id: string;
  requestReviewDocumentId: string;
  noteType: string;
  note: string;
  dateCreated: Date;
  createdById: string;
  createdByName: string;
}

//interface extention for custom built items like time in a datetime
export interface IRequestReviewDocumentNoteFormValues
  extends Partial<IRequestReviewDocumentNote> {
}

//empty form model
export class RequestReviewDocumentNoteFormValues
  implements IRequestReviewDocumentNoteFormValues {
  id: string = "";
  requestReviewDocumentId: string = "";
  noteType: string = "";
  note: string = "";

  dateCreated?: Date = undefined;
  createdById: string = "";
  createdByName: string = "";

  constructor(requestReviewDocumentId?: string) {
    if (requestReviewDocumentId) {
      this.requestReviewDocumentId = requestReviewDocumentId;
    }
    Object.assign(this);
  }
}
